module.exports = __webpack_public_path__ + "static/img/04@2x.092a52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/04@2x.png
// module id = qsRu
// module chunks = 1